var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 32C24.9616 32 32.125 24.8366 32.125 16C32.125 7.16344 24.9616 0 16.125 0C7.28844 0 0.125 7.16344 0.125 16C0.125 24.8366 7.28844 32 16.125 32Z",
    fill: "#103F68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.105 5.01801L25.625 10.501V21.501L16.116 27L16.039 26.981L6.625 21.501V10.501L16.039 5.01801H16.105ZM16.074 6.15601L7.625 11.076V20.926L16.073 25.845L17.105 25.248L24.625 20.923V11.078L17.105 6.72801L16.074 6.15601ZM8.934 16.766L11.435 14.896L13.646 16.308V18.848L15.319 20.46L15.318 21.216L13.706 22.726H12.345L8.935 16.766H8.934ZM16.837 21.218L16.834 20.458L18.501 18.848V16.308L20.688 14.878L23.184 16.767L19.791 22.709H18.447L16.837 21.218ZM14.467 16.308L13.653 14.177H18.491L17.693 16.308L17.929 18.69L16.062 18.694L14.217 18.697L14.467 16.308ZM16.062 13.593L11.464 13.591L12.319 9.77101H19.783L20.683 13.596L16.062 13.593Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCrypto);
export default __webpack_public_path__ + "static/media/ic_crypto.ae58d67ce9ff7cc5a52adef17e041a53.svg";
export { ForwardRef as ReactComponent };